import { Component, OnInit, HostListener } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from '@services/auth/auth.service';
import { EstadoSistemaTimerService } from '@services/sistema/estadosistematimer.service';
import { ToolsService } from '@services/varios/tools.service';
import { PerfilUsuario } from 'src/app/common/interfaces/perfil-usuario.interface';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss']
})

export class AppHeaderComponent implements OnInit {
  isSmallScreen = false;
  public logUserName: string = "";
  public perfilName: string = "";
  public direccionRegional: string = "";
  public unidad: string = "";
  public perfiles: PerfilUsuario[] = [];
  public visibleArrow: boolean = false;
  public isOpen = false;
  public selectedPerfil: PerfilUsuario = {} as PerfilUsuario;
  UsrInfo: any;

  constructor(private readonly router: Router, private readonly authService: AuthService, public readonly toolsService: ToolsService, private readonly estadoSistemaTimer: EstadoSistemaTimerService) {
    this.checkScreenSize();
  }

  @HostListener('window:resize', ['$event'])
  onResize(event: any) {
    this.checkScreenSize();
  }

  private checkScreenSize() {
    this.isSmallScreen = window.innerWidth < 768;
    if (this.UsrInfo != null) {
      if (this.isSmallScreen) {
        let data: string[] = this.UsrInfo.usuario.nombres.toString().split(" ");
        if (data.length == 0) {
          this.logUserName = this.UsrInfo.usuario.nombres;
        } else {
          this.logUserName = data[0];
        }
      } else {
        this.logUserName = this.UsrInfo.usuario.nombres + " " + this.UsrInfo.usuario.apellidoPaterno;
      }
    }
  }

  async ngOnInit() {
      this.UsrInfo = this.authService.getUserInfo();
      this.perfilName = this.UsrInfo.usuario.nombrePerfil;
      this.perfiles = this.UsrInfo.usuario.perfiles;
      this.selectedPerfil = this.perfiles.filter(x => x.nombrePerfil == this.perfilName)[0];
      this.visibleArrow = this.perfiles.length > 1;
      this.direccionRegional = this.UsrInfo.usuario.direccionRegional;
      this.unidad = this.UsrInfo.usuario.unidad;

      this.checkScreenSize();
  }

  @HostListener('document:click', ['$event'])
  onClickOutside(event: Event) {
    if (this.isOpen) {
      this.isOpen = false;
    }
  }

  toggleDropdown(event: Event) {
    event.stopPropagation();
    this.isOpen = !this.isOpen;
  }

  async selectPerfil(perfil: PerfilUsuario) {
    this.isOpen = false;

    if (perfil.nombrePerfil != this.UsrInfo.usuario.nombrePerfil) {
      let respuesta = await this.toolsService.confirmaMensaje('Cambio de perfil', '¿Está seguro de cambiar su perfil?, asegúrese de guardar su trabajo!');
      if (respuesta) {
        this.selectedPerfil = perfil;
        this.UsrInfo.usuario.nombrePerfil = perfil.nombrePerfil;
        this.UsrInfo.usuario.idPerfil = perfil.idPerfil;
        this.UsrInfo.usuario.usarDatosNacionales = perfil.usarDatosNacionales;
        const dataUsuario = JSON.stringify(this.UsrInfo);
        sessionStorage.setItem('USUARIO', dataUsuario);

        let rutaActual: string = this.router.url.substring(1);
        let rutaDestino: string = this.toolsService.itemMenuDefault();

        this.router.navigate([rutaDestino]);

        if (rutaActual === rutaDestino) {
          window.location.reload();
        }
      }
    }
  }

  async logOut() {
    this.authService.signOut();
  }
}